// // // src/App.js
// // import React from 'react';
// // import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// // import Login from './components/Login';
// // import Signup from './components/SignUp';
// // import Dashboard from './components/Dashboard';
// // import SessionProvider from './hooks/SessionProvider';

// // // ✅ ADD THIS IMPORT
// // import ProtectedRoute from './utils/ProtectedRoute';

// // function App() {
// //   return (
// //     <Router>
// //       <SessionProvider>
// //         <Routes>
// //           <Route path="/" element={<Navigate to="/login" />} />
// //           <Route path="/login" element={<Login />} />
// //           <Route path="/signup" element={<Signup />} />

// //           {/* ✅ PROTECTED DASHBOARD */}
// //           <Route
// //             path="/dashboard"
// //             element={
// //               <ProtectedRoute>
// //                 <Dashboard />
// //               </ProtectedRoute>
// //             }
// //           />

// //           {/* ✅ SAME AS DASHBOARD */}
// //           <Route
// //             path="/HOME"
// //             element={
// //               <ProtectedRoute>
// //                 <Dashboard />
// //               </ProtectedRoute>
// //             }
// //           />

// //         </Routes>
// //       </SessionProvider>
// //     </Router>
// //   );
// // }

// //export default App;
// // src/App.js
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './components/Login';
// import Signup from './components/SignUp';
// import Dashboard from './components/Dashboard';
// import EmployeeProduction from './components/EmployeeProduction';
// import SessionProvider from './hooks/SessionProvider';
// import ProtectedRoute from './utils/ProtectedRoute';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Navigate to="/login" />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
        
//         {/* Production page - NO SessionProvider */}
//         <Route path="/employee-production" element={<EmployeeProduction />} />
        
//         {/* All other pages - WITH SessionProvider */}
//         <Route path="/*" element={
//           <SessionProvider>
//             <Routes>
//               <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute>
//                 <Dashboard />
//               </ProtectedRoute>
//             }
//           />

//           {/* ✅ SAME AS DASHBOARD */}
//           <Route
//             path="/HOME"
//             element={
//               <ProtectedRoute>
//                 <Dashboard />
//               </ProtectedRoute>
//             }
//           />
//               {/* Add other protected routes here */}
//             </Routes>
//           </SessionProvider>
//         } />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// src/App.js
// src/App.js - CORRECTED VERSION
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Signup from './components/SignUp';
import Dashboard from './components/Dashboard';
import EmployeeProduction from './components/EmployeeProduction';
import SessionProvider from './hooks/SessionProvider';
import ProductionSessionProvider from './hooks/ProductionSessionProvider';
import ProtectedRoute from './utils/ProtectedRoute';
import DeliveryChalan from './components/DeliveryChalan';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        
        {/* Employee Production page - With NO session checking */}
        <Route path="/employee-production" element={
          <ProductionSessionProvider>
            <EmployeeProduction />
          </ProductionSessionProvider>
        } />
        
        {/* Dashboard routes - WITH session checking */}
        <Route path="/dashboard" element={
          <SessionProvider>
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          </SessionProvider>
        } />
        
        <Route path="/HOME" element={
          <SessionProvider>
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          </SessionProvider>
        } />
      </Routes>
    </Router>
  );
}

export default App;